module.exports = __webpack_public_path__ + "files/0a5c4fa9ad04c074f47181a5cc92580f.png";